import * as StM from '../../models/store';
import BaseReducer from '../baseReducer';
import * as _ from 'lodash';

export default class AddUserDialogReducer extends BaseReducer {
    static handle(state: StM.IAddUserDialogStoreState = new StM.AddUserDialogStoreState(), action: any): StM.IAddUserDialogStoreState {
        switch (action.type) {
            case 'Dialogs/Admin/AddUser/Open': {
                return <StM.IAddUserDialogStoreState>_.assign({}, state, { isOpened: true });
            }
            case 'Dialogs/Admin/AddUser/Close': {
                return <StM.IAddUserDialogStoreState>_.assign({}, state, { isOpened: false });
            }
            default: {
                return state;
            }
        }
    }
}
